module.exports = __webpack_public_path__ + "static/img/malldomin.46cc9ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/malldomin.png
// module id = sj/c
// module chunks = 1 2 3 4 5 6 7 8 9